import Swiper from 'swiper/dist/js/swiper';
import breakpoints from '../helpers/breakpoints';

export default class {
  constructor($c) {
    const container = $c.find('.js-services-slider-container');
    const prev = $c.find('.js-services-slider-prev');
    const next = $c.find('.js-services-slider-next');

    this.swiper = new Swiper(container, {
      navigation: { prevEl: prev, nextEl: next },
      loop: true,
      slidesPerView: 3,
      spaceBetween: 32,
      simulateTouch: false,
      breakpoints: {
        [breakpoints.mobile]: {
          slidesPerView: 1
        }
      }
    });
  }
}
